export function enumFromStringValue(enm, value, def) {
    return Object.values(enm).includes(value)
        ? value
        : def;
}
